import React, { useState, useMemo, useEffect } from 'react'
import { Button, Card, Checkbox, Col, Divider, Input, message, Modal, Row, Select, Table, Tag } from 'antd';
import VisitaModal from './visita.modal';
import { API, DOMAIN, getData, sendDataBody, updateData, usuario } from '../../resources';
import { DownloadOutlined, PlusOutlined, ShareAltOutlined, ReloadOutlined } from '@ant-design/icons'
import SolicitudKetaminaModal from './printed-docs/solicitudVisitaPrint';
import { useHistory } from 'react-router-dom';
import EscalasEMTModal from './visitas-details/escalas-emt-modal';
import EfectosSatisfactionModal from './visitas-details/emt-efectos-satisfaction-results-modal';
import KetaScalaDetailsModal from './visitas-details/keta/keta-details-modal';
import VisitaDelete from './visitas-delete';

// PARENT: Expedientes

export default function Visitas({ id_paciente, pacienteData }) {
    const navHistory = useHistory();

    const [visitas, setVisitas] = useState([])


    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };


    useEffect(() => {
        getVisitas()
    }, [])

    const getVisitas = () => getData(`visitas/${id_paciente}`).then(setVisitas)

    useEffect(() => {
        getVisitas()
    }, [isModalOpen])




    return (
        <Card style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <h5>Tratamientos</h5>

                <Button type="primary" ghost onClick={showModal} shape='round' icon={<PlusOutlined />} style={{ marginBottom: 10 }} >
                    Nuevo tratamiento
                </Button>
            </div>

            {visitas.length === 0 && (
                <div style={{ textAlign: 'center', padding: '32px 0', color: '#bbb' }}>
                    Sin tratamientos registrados
                </div>
            )}
            {visitas.map((visita, i) => (
                <div key={i} style={{ marginTop: 16 }}>
                    {visita.tipo_visita === "Estudio" && <DetailsEstudio visita={visita} />}
                    {visita.tipo_visita === "Evolucion" && <DetailsSoap visita={visita} />}
                    {visita.tipo_visita === "tratamiento_ketamina" && <DetailsKetamina pacienteData={pacienteData} visita={visita} id_paciente={id_paciente} getVisitas={getVisitas} />}
                    {visita.tipo_visita === "tratamiento_emt" && <DetailsEMT visita={visita} id_paciente={id_paciente} getVisitas={getVisitas} pacienteData={pacienteData} />}
                </div>
            ))}

            <VisitaModal medico={pacienteData?.medicos_asignados?.[0]?.name ?? ''} id_paciente={id_paciente} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />

        </Card>
    )
}

function DetailsEstudio({ visita }) {
    return (
        <Card style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <Tag color="cyan">Estudio</Tag>
                <span style={{ fontSize: 12, color: '#8c8c8c' }}>{new Date(visita.createdAt).toLocaleDateString()}</span>
            </div>
            <Button icon={<DownloadOutlined />} type='dashed' href={API + '/notas/estudios/download/' + visita.estudio}>Descargar estudio</Button>
        </Card>
    )
}

function DetailsSoap({ visita }) {
    return (
        <Card style={{ marginBottom: 10 }}>
            <div style={{ marginBottom: 10 }}>
                <Tag color="green">Nota de Evolución</Tag>
            </div>
            <div style={{ whiteSpace: 'pre-line', fontSize: 13 }}>{visita.soap}</div>
        </Card>
    )
}


//  KETAMINA
// This is the request or table of ketamina sessions
function DetailsKetamina({ visita, id_paciente, getVisitas, pacienteData }) {

    // INITIAL TABLE

    const [scalesTable, setScalesTable] = useState([])

    useEffect(() => {



        getTable()
    }, [])

    const getTable = () => {
        getData(`/encuestas/ketaminatable/${id_paciente}/${visita._id}`).then((res) => {
            setScalesTable(res)
        })
    }

    const getResultadoKetamina = (tipo, sesion) => {

        // Buscar en los datos del API
        const item = scalesTable.find(data =>
            data.tipo === tipo &&
            data.sesion == sesion
        );

        // console.log(`item found ${tipo} ${sesion}`, item || 'not found')

        return item ? '🔵' : '🔴';
    };

    const getOptionalREsultadoKetamina = (tipo, sesion) => {
        // Buscar en los datos del API
        const item = scalesTable.find(data =>
            data.tipo === tipo &&
            data.sesion == sesion
        );
        // console.log(`item found ${tipo} ${sesion}`, item || 'not found')
        return item ? '🔵' : '🟡';
    };
    // INITIAL TABLE


    const [isDetailsScalaModalOpen, setIsDetailsScalaModalOpen] = useState(false)
    const [session, setSession] = useState({})
    const [enfermero, setEnfermero] = useState('')
    const [encuestaDetails, setEncuestaDetails] = useState({})


    const handleCancel = () => {
        setIsDetailsScalaModalOpen(false);
    };


    const generateScalaUrl = (tipo, session) => {
        navigator.clipboard.writeText(`${DOMAIN}${tipo}_public/${usuario._id}/${pacienteData._id}/Ketamina/${visita._id}/${session}/default`)
        message.success('Enlace copiado al portapapeles');
    }

    const [chainModalVisible, setChainModalVisible] = useState(false)
    const [chainSession, setChainSession] = useState(null)
    const [chainOptionals, setChainOptionals] = useState({ emca: false, dolor_2: false, post_traumatico: false })

    const openChainModal = (session) => {
        setChainSession(session)
        setChainOptionals({ emca: false, dolor_2: false, post_traumatico: false })
        setChainModalVisible(true)
    }

    const handleChainCopy = () => {
        const mandatory = ['phq9p', 'gad_7', 'cssrs']
        const optionals = []
        if (chainOptionals.cadss) optionals.push('cadss')
        if (chainOptionals.emca) optionals.push('emca')
        if (chainOptionals.dolor_2) optionals.push('dolor_2')
        if (chainOptionals.post_traumatico) optionals.push('post_traumatico')
        const chainString = [...mandatory, ...optionals].join(',')
        navigator.clipboard.writeText(`${DOMAIN}phq9p_public/${usuario._id}/${pacienteData._id}/Ketamina/${visita._id}/${chainSession}/default?chain=${chainString}`)
        message.success('Paquete de escalas copiado al portapapeles')
        setChainModalVisible(false)
    }

    const copyWithNoChain = (tipo, session) => {
        navigator.clipboard.writeText(`${DOMAIN}${tipo}_public/${usuario._id}/${pacienteData._id}/Ketamina/${visita._id}/${session}/default`)
        message.success('Enlace copiado al portapapeles');
    }

    const checkEncuesta = (tipo, session) => {

        const URL_TO_SEARCH = `encuestas/find/${id_paciente}/${visita._id}/${tipo}/${session}/default`
        console.log('searching', URL_TO_SEARCH)
        getData(URL_TO_SEARCH).then(rs => {
            // console.log('response at search ', rs)
            if (rs.message === 'The survey does not exist')
                generateScalaUrl(tipo, session)
            else {

                setEncuestaDetails(rs)
                setIsDetailsScalaModalOpen(true)
            }
        })
    }

    const dataSource = [
        {
            key: '3',
            name: 'PHQ-9',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('phq9p', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('phq9p', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('phq9p', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('phq9p', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('phq9p', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('phq9p', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('phq9p', 10)}</span>,
        },
        {
            key: '4',
            name: 'GAD-7',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('gad_7', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('gad_7', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('gad_7', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('gad_7', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('gad_7', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('gad_7', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('gad_7', 10)}</span>,
        },
        {
            key: '5',
            name: 'Columbia',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cssrs', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cssrs', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cssrs', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cssrs', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('cssrs', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cssrs', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('cssrs', 10)}</span>,
        },
        {
            key: '6',
            name: 'CADSS',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 1)}</span>,
            S2: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 2) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 2)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 3)}</span>,
            S4: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 4) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 4)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 5)}</span>,
            S6: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 6) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 6)}</span>,
            S7: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 7) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 7)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('cadss', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('cadss', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('cadss', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('cadss', 10)}</span>,
        },
        {
            key: '7',
            name: 'emca',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('emca', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('emca', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('emca', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('emca', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('emca', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('emca', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('emca', 10)}</span>,
        },
        {
            key: '8',
            name: 'dolor',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('dolor_2', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('dolor_2', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('dolor_2', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('dolor_2', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('dolor_2', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('dolor_2', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('dolor_2', 10)}</span>,
        },
        {
            key: '9',
            name: 'estres',
            S1: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 1) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('post_traumatico', 1)}</span>,
            S3: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 3) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('post_traumatico', 3)}</span>,
            S5: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 5) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('post_traumatico', 5)}</span>,
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('post_traumatico', 8)}</span>,
            S9: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 9) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('post_traumatico', 9)}</span>,
            S10: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('post_traumatico', 10) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getOptionalREsultadoKetamina('post_traumatico', 10)}</span>,
        },
        {
            key: '10',
            name: 'Enc. Satisfacción',
            S8: <span style={{ cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={() => { checkEncuesta('satisfaccion_2', 8) }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>{getResultadoKetamina('satisfaccion_2', 8)}</span>,
        },

    ];

    const columns = [
        {
            title: 'Sesión',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(1)}>S1</span>,
            dataIndex: 'S1',
            key: 'S1',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => copyWithNoChain('cadss', 2)}>S2</span>,
            dataIndex: 'S2',
            key: 'S2',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(3)}>S3</span>,
            dataIndex: 'S3',
            key: 'S3',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => copyWithNoChain('cadss', 4)}>S4</span>,
            dataIndex: 'S4',
            key: 'S4',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(5)}>S5</span>,
            dataIndex: 'S5',
            key: 'S5',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => copyWithNoChain('cadss', 6)}>S6</span>,
            dataIndex: 'S6',
            key: 'S6',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => copyWithNoChain('cadss', 7)}>S7</span>,
            dataIndex: 'S7',
            key: 'S7',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(8)}>S8</span>,
            dataIndex: 'S8',
            key: 'S8',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(9)}>R1</span>,
            dataIndex: 'S9',
            key: 'S9',
        },
        {
            title: <span style={{ cursor: 'pointer' }} onClick={() => openChainModal(10)}>R2</span>,
            dataIndex: 'S10',
            key: 'S10',
        }
    ];

    const approveVisita = () => {
        updateData(`visitas/update/${visita._id}`, { aprobado: true }).then(getVisitas)
    }

    const LineDesc = ({ label, data }) => (<Row ><Col span={8}><span style={{ fontWeight: 400, color: "#717f91" }}>{label}:</span></Col>  <Col><span style={{ fontWeight: '600' }}>{data}</span></Col> </Row>)

    const MapDesc = ({ label, data, zebra }) => (
        <Row style={{ backgroundColor: zebra ? '#f7f8fa' : 'transparent', padding: 8, borderRadius: 5 }}>
            <Col span={8}>
                <span style={{ fontWeight: 400, color: "#717f91" }}>{label}:</span>
            </Col>
            <Col>
                {data.map((d, i) => (
                    <div key={i} style={{ fontWeight: '600' }}>{d}</div>
                ))}
            </Col>
        </Row>
    )

    // Add a usestate for a modal to show the Solicitud Ketamina modal
    const [isModalPrintOpen, setIsModalPrintOpen] = useState(false)
    const showSolicitudKetaminaModal = () => {
        setIsModalPrintOpen(true);
    };





    return (
        <Card style={{ marginTop: 10, marginBottom: 10, display: 'flex', flexDirection: 'column' }}>

            {
                visita.aprobado ? <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Tag color="gold" style={{ marginBottom: 12 }}>Ketamina</Tag> <Button type='primary' size='small' ghost onClick={getTable} shape="circle" icon={<ReloadOutlined />} />
                    </div>
                    <Table dataSource={dataSource} columns={columns} size='small' />
                    <br />
                    <Button type='primary' ghost onClick={showSolicitudKetaminaModal} icon={<DownloadOutlined />} style={{ marginBottom: 10 }} >Imprimir solicitud Ketamina</Button>
                    <VisitaDelete id_visita={visita._id} getVisitas={getVisitas} />
                </div>
                    :
                    <div>
                        <Tag color="gold" style={{ marginBottom: 12 }}>Solicitud — Ketamina</Tag>
                        <LineDesc label='Numero de sesiones' data={visita.numero_sesiones} />
                        <MapDesc label='Historial relevante' data={visita.historial_relevante} zebra />
                        <MapDesc label='Tratamientos previos' data={visita.tratamientos_previos} />
                        <MapDesc label='Medicacion actual' data={visita.medicacion_actual} zebra />
                        <LineDesc label='Encargado' data={visita.encargado} />
                        <LineDesc label='Precio' data={visita.precio} />
                        <br />
                        <Button type='primary' ghost onClick={approveVisita} >Aprobar</Button>
                        <Button onClick={showSolicitudKetaminaModal} icon={<DownloadOutlined />} style={{ marginBottom: 10 }} >Imprimir solicitud Ketamina</Button>
                        <VisitaDelete id_visita={visita._id} getVisitas={getVisitas} />
                    </div>
            }

            <Modal
                title="Seleccionar encuestas opcionales"
                open={chainModalVisible}
                onCancel={() => setChainModalVisible(false)}
                onOk={handleChainCopy}
                okText="Copiar enlace"
                cancelText="Cancelar"
            >
                <p>Las encuestas obligatorias (PHQ-9, GAD-7, Columbia) se incluyen automáticamente.</p>
                <p>Seleccione las encuestas opcionales:</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <Checkbox checked={chainOptionals.cadss} onChange={(e) => setChainOptionals({ ...chainOptionals, cadss: e.target.checked })}>CADSS</Checkbox>
                    <Checkbox checked={chainOptionals.emca} onChange={(e) => setChainOptionals({ ...chainOptionals, emca: e.target.checked })}>EMCA</Checkbox>
                    <Checkbox checked={chainOptionals.dolor_2} onChange={(e) => setChainOptionals({ ...chainOptionals, dolor_2: e.target.checked })}>Dolor</Checkbox>
                    <Checkbox checked={chainOptionals.post_traumatico} onChange={(e) => setChainOptionals({ ...chainOptionals, post_traumatico: e.target.checked })}>Estrés Post-Traumático</Checkbox>
                </div>
            </Modal>

            <KetaScalaDetailsModal isDetailsKetaScalaModalOpen={isDetailsScalaModalOpen} handleCancel={handleCancel} encuestaDetails={encuestaDetails} pacienteData={pacienteData} />

            <SolicitudKetaminaModal tipo="Infusión con Ketamina" isModalOpen={isModalPrintOpen} setIsModalOpen={setIsModalPrintOpen} pacienteData={pacienteData} visitaData={visita} />
        </Card>
    )
}


// EMT
// This is the request or table of EMT sessions
function DetailsEMT({ visita, id_paciente, getVisitas, pacienteData }) {

    const history = useHistory();

    const [encuestaDetails, setEncuestaDetails] = useState({})
    const [encuestaDetailsModalOpen, setEncuestaDetailsModalOpen] = useState(false)

    const cellStyle = { cursor: 'pointer', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }

    const copyEMTClipboard = ({ tipo, session }) => {
        const link = `${DOMAIN}${tipo}_public/${usuario._id}/${visita.id_paciente}/EMT/${visita._id}/${session}/default`;
        navigator.clipboard.writeText(link)
        message.success('Enlace copiado al portapapeles');
    }

    const fastEMTCheck = (tipo, session, protocolo = 'default') => {
        const URL_TO_SEARCH = `encuestas/find/${visita.id_paciente}/${visita._id}/${tipo}/${session}/${protocolo}`
        console.log('searching', URL_TO_SEARCH)
        getData(URL_TO_SEARCH).then(rs => {
            console.log('response at search ', rs)
            if (rs.message === 'The survey does not exist')
                copyEMTClipboard({ tipo, session })
            else {

                setEncuestaDetails(rs)
                setEncuestaDetailsModalOpen(true)
            }
        })
    }
    const columns = [
        {
            title: 'Protocolo',
            dataIndex: 'protocolo',
            key: 'protocolo'
        },
        {
            title: 'Sesión 1',
            dataIndex: 'S1',
            key: 'S1'
        },
        {
            title: 'Sesiones de aplicación',
            dataIndex: 'S2',
            key: 'S2',
        },
        {
            title: 'Última sesión',
            dataIndex: 'S3',
            key: 'S3',
            // render: (_, { S1, name }) => (<div style={cellStyle} onClick={() => { showModal({ n_session: 1, name }); }} onMouseOver={(e) => e.target.style.background = '#6bd4fa'} onMouseOut={(e) => e.target.style.background = ''}>{S1}</div>),
        },
        {
            title: 'Sesión seguimiento',
            dataIndex: 'S4',
            key: 'S4',
            // render: (_, { S2, name }) => (<div style={cellStyle} onClick={() => { showModal({ n_session: 2, name }); }} onMouseOver={(e) => e.target.style.background = '#6bd4fa'} onMouseOut={(e) => e.target.style.background = ''}>{S2}</div>),
        },
        {
            title: 'Mantenimiento inicial',
            dataIndex: 'S5',
            key: 'S5',
            // render: (_, { S3, name }) => (<div style={cellStyle} onClick={() => { showModal({ n_session: 3, name }); }} onMouseOver={(e) => e.target.style.background = '#6bd4fa'} onMouseOut={(e) => e.target.style.background = ''}>{S3}</div>),
        },
        {
            title: 'Sesiones de aplicación de mantenimiento',
            dataIndex: 'S6',
            key: 'S6',
            // render: (_, { S4, name }) => (<div style={cellStyle} onClick={() => { showModal({ n_session: 4, name }); }} onMouseOver={(e) => e.target.style.background = '#6bd4fa'} onMouseOut={(e) => e.target.style.background = ''}>{S4}</div>),
        },
        {
            title: 'Sesión de mantenimiento final',
            dataIndex: 'S7',
            key: 'S7',
            // render: (_, { S5, name }) => (<div style={cellStyle} onClick={() => { showModal({ n_session: 5, name }); }} onMouseOver={(e) => e.target.style.background = '#6bd4fa'} onMouseOut={(e) => e.target.style.background = ''}>{S5}</div>),
        },
    ];


    const dataSource = [
        // {
        //     key: '1',
        //     protocolo: 'Consentimiento informado',
        //     S1: '°'
        // },
        {
            key: '2',
            protocolo: 'Escalas de acuerdo al protocolo',
            S1: <span style={cellStyle} onClick={() => { history.push("/escalas-emt", { visita, session: 1 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S3: <span style={cellStyle} onClick={() => { history.push("/escalas-emt", { visita, session: 3 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S4: <span style={cellStyle} onClick={() => { history.push("/escalas-emt", { visita, session: 4 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S5: <span style={cellStyle} onClick={() => { history.push("/escalas-emt", { visita, session: 5 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S7: <span style={cellStyle} onClick={() => { history.push("/escalas-emt", { visita, session: 7 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
        },
        {
            key: '3',
            protocolo: 'Hoja de registro EMT',
            S1: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 1 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S2: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 2 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S3: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 3 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S5: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 5 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S6: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 6 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
            S7: <span style={cellStyle} onClick={() => { history.push("/hoja-registro-emt", { visita, session: 7 }); }} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>,
        },
        {
            key: '4',
            protocolo: 'Lista verif. Efectos EMT',
            S3: <span style={cellStyle} onClick={() => fastEMTCheck('efectos_emt', 3, 'default')} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>
        },
        {
            key: '5',
            protocolo: 'Encuesta de satisfaccion',
            S3: <span style={cellStyle} onClick={() => fastEMTCheck('satisfaccion_2', 3, 'default')} onMouseOver={(e) => { e.target.style.background = '#6bd4fa'; e.target.style.cursor = 'pointer' }} onMouseOut={(e) => e.target.style.background = ''}>🔵</span>
        },
        // {
        //     key: '6',
        //     protocolo: 'Alta paciente',
        //     S3: '°'
        // }
    ];



    const approveVisita = () => {
        updateData(`visitas/update/${visita._id}`, { aprobado: true }).then(getVisitas)
    }

    const goToDetails = () => {
        history.push("/escalas-emt", {
            visita
        });
    };

    const LineDesc = ({ label, data }) => (<Row ><Col span={8}><span style={{ fontWeight: 400, color: "#717f91" }}>{label}:</span></Col>  <Col><span style={{ fontWeight: '600' }}>{data}</span></Col> </Row>)


    // Solicitud EMT functions and hooks
    const [isModalPrintOpen, setIsModalPrintOpen] = useState(false)
    const showSolicitudKetaminaModal = () => {
        setIsModalPrintOpen(true);
    };
    return <Card>
        {
            visita.aprobado ? <div>
                <Tag color="purple" style={{ marginBottom: 12 }}>EMT</Tag>
                <Table dataSource={dataSource} columns={columns} size='small' />
                <br />
                <Button type='primary' ghost onClick={showSolicitudKetaminaModal} icon={<DownloadOutlined />} style={{ marginBottom: 10 }} >Imprimir solicitud EMT</Button>
                <VisitaDelete id_visita={visita._id} getVisitas={getVisitas} />
            </div>
                :
                <div>
                    <Tag color="purple" style={{ marginBottom: 12 }}>Solicitud — EMT</Tag>
                    <LineDesc label='Numero de sesiones' data={visita.numero_sesiones} />
                    <LineDesc label='Historial relevante' data={visita.historial_relevante} />
                    <LineDesc label='Tratamientos previos' data={visita.tratamientos_previos} />
                    <LineDesc label='Medicacion actual' data={visita.medicacion_actual} />
                    <LineDesc label='Encargado' data={visita.encargado} />
                    <LineDesc label='Precio' data={visita.precio} />
                    <br />
                    <Button onClick={approveVisita} >Aprobar</Button>
                    <Button type='primary' ghost onClick={showSolicitudKetaminaModal} icon={<DownloadOutlined />} style={{ marginBottom: 10 }} >Imprimir solicitud EMT</Button>
                    <VisitaDelete id_visita={visita._id} getVisitas={getVisitas} />
                </div>
        }


        <SolicitudKetaminaModal tipo="Estimulación Magnetica Transcraneal" isModalOpen={isModalPrintOpen} setIsModalOpen={setIsModalPrintOpen} pacienteData={pacienteData} visitaData={visita} />

        <EfectosSatisfactionModal encuestaDetails={encuestaDetails} isModalOpen={encuestaDetailsModalOpen} setIsModalOpen={setEncuestaDetailsModalOpen} />


    </Card>
}
